<script>
  import options from './SchemaMarkupDate.options'
  export default options
</script>

<template>
  <div class="kb-field" :class="{ 'kb-field--readonly': readonly }">
    <label v-if="label" :for="fieldId" class="kb-field__label">{{ label }}</label>

    <input
      :id="fieldId"
      class="kb-field__input"
      type="text"
      :value="modelValue"
      :placeholder="format"
      :readonly="readonly"
      @input="onInput"
    />
  </div>
</template>
